// @flow weak

import _ from 'lodash/fp';
import {ADD as NOTIFICATION} from './notification';
import {
  GET,
  PUT,
  POST,
  DELETE,
} from '../helpers/request';
import {STANDARD, SPECIAL} from '../assortments';
import {ADMIN} from '../roles.js';
import {addNotification} from './notification';

export const GET_REQUEST = '@orderView/GET_REQUEST';
export const GET_SUCCESS = '@orderView/GET_SUCCESS';
export const GET_FAILURE = '@orderView/GET_FAILURE';

export const CREATE_REQUEST = '@orderView/CREATE_REQUEST';
export const CREATE_SUCCESS = '@orderView/CREATE_SUCCESS';
export const CREATE_FAILURE = '@orderView/CREATE_FAILURE';

export const UPDATE_REQUEST = '@orderView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@orderView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@orderView/UPDATE_FAILURE';

export const ORDER_ROWS_UPDATE_REQUEST = '@orderView/ORDER_ROWS_UPDATE_REQUEST';
export const ORDER_ROWS_UPDATE_SUCCESS = '@orderView/ORDER_ROWS_UPDATE_SUCCESS';
export const ORDER_ROWS_UPDATE_FAILURE = '@orderView/ORDER_ROWS_UPDATE_FAILURE';

export const ORDER_ROWS_CLEAR_REQUEST = '@orderView/ORDER_ROWS_CLEAR_REQUEST';
export const ORDER_ROWS_CLEAR_SUCCESS = '@orderView/ORDER_ROWS_CLEAR_SUCCESS';
export const ORDER_ROWS_CLEAR_FAILURE = '@orderView/ORDER_ROWS_CLEAR_FAILURE';

export const RESET = '@orderView/RESET';
export const CLEAR = '@orderView/CLEAR';

export const ORDER_ROW_UPDATE_REQUEST = '@orderView/ORDER_ROW_UPDATE_REQUEST';
export const ORDER_ROW_UPDATE_SUCCESS = '@orderView/ORDER_ROW_UPDATE_SUCCESS';
export const ORDER_ROW_UPDATE_FAILURE = '@orderView/ORDER_ROW_UPDATE_FAILURE';

export const SET_NOTE_ROW = '@orderView/SET_NOTE_ROW';

export const ORDER_COMMENT_CREATE_REQUEST = '@orderView/ORDER_COMMENT_CREATE_REQUEST';
export const ORDER_COMMENT_CREATE_SUCCESS = '@orderView/ORDER_COMMENT_CREATE_SUCCESS';
export const ORDER_COMMENT_CREATE_FAILURE = '@orderView/ORDER_COMMENT_CREATE_FAILURE';

export const ORDER_COMMENT_REMOVE_REQUEST = '@orderView/ORDER_COMMENT_REMOVE_REQUEST';
export const ORDER_COMMENT_REMOVE_SUCCESS = '@orderView/ORDER_COMMENT_REMOVE_SUCCESS';
export const ORDER_COMMENT_REMOVE_FAILURE = '@orderView/ORDER_COMMENT_REMOVE_FAILURE';

export const ORDER_COMMENT_UPDATE_REQUEST = '@orderView/ORDER_COMMENT_UPDATE_REQUEST';
export const ORDER_COMMENT_UPDATE_SUCCESS = '@orderView/ORDER_COMMENT_UPDATE_SUCCESS';
export const ORDER_COMMENT_UPDATE_FAILURE = '@orderView/ORDER_COMMENT_UPDATE_FAILURE';

export const SET_ACTIVE_EXTRA_ROW = '@orderView/SET_ACTIVE_EXTRA_ROW';
export const EXTRA_ROW_UPDATE_REQUEST = '@orderView/EXTRA_ROW_UPDATE_REQUEST';
export const EXTRA_ROW_UPDATE_SUCCESS = '@orderView/EXTRA_ROW_UPDATE_SUCCESS';
export const EXTRA_ROW_UPDATE_FAILURE = '@orderView/EXTRA_ROW_UPDATE_FAILURE';

export const EXTRA_ROW_CREATE_REQUEST = '@orderView/EXTRA_ROW_CREATE_REQUEST';
export const EXTRA_ROW_CREATE_SUCCESS = '@orderView/EXTRA_ROW_CREATE_SUCCESS';
export const EXTRA_ROW_CREATE_FAILURE = '@orderView/EXTRA_ROW_CREATE_FAILURE';

export const EXTRA_ROW_REMOVE_REQUEST = '@orderView/EXTRA_ROW_REMOVE_REQUEST';
export const EXTRA_ROW_REMOVE_SUCCESS = '@orderView/EXTRA_ROW_REMOVE_SUCCESS';
export const EXTRA_ROW_REMOVE_FAILURE = '@orderView/EXTRA_ROW_REMOVE_FAILURE';

export const ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST = '@orderView/ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST';
export const ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS = '@orderView/ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS';
export const ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE = '@orderView/ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE';

export const ACTIVE_EXTRA_ROW_VARIANTS_REQUEST = '@orderView/ACTIVE_EXTRA_ROW_VARIANTS_REQUEST';
export const ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS = '@orderView/ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS';
export const ACTIVE_EXTRA_ROW_VARIANTS_FAILURE = '@orderView/ACTIVE_EXTRA_ROW_VARIANTS_FAILURE';

export const SET_ACTIVE_COMMENT = '@orderView/SET_ACTIVE_COMMENT';

export const UPDATE_REPORT_FILTER = '@orderView/UPDATE_REPORT_FILTER';
export const UPDATE_USER_ORDER_FILTER = '@orderView/UPDATE_USER_ORDER_FILTER';

export const updateUserOrderFilter = (includePlans: boolean) => ({
  type: UPDATE_USER_ORDER_FILTER,
  includePlans,
});

export const updateReportFilter = (supplierId: ?number, includePlans: boolean) => ({
  type: UPDATE_REPORT_FILTER,
  supplierId,
  includePlans,
});

export const setActiveComment = comment => ({
  type: SET_ACTIVE_COMMENT,
  comment,
});

const orderCommentCreateRequest = () => ({
  type: ORDER_COMMENT_CREATE_REQUEST,
});

const orderCommentCreateSuccess = comment => ({
  type: ORDER_COMMENT_CREATE_SUCCESS,
  comment,
  [NOTIFICATION]: {
    message: 'Kommentar skapad',
  },
});

const orderCommentCreateFailure = error => ({
  type: ORDER_COMMENT_CREATE_FAILURE,
  error,
});

const orderCommentRemoveRequest = () => ({
  type: ORDER_COMMENT_REMOVE_REQUEST,
});

const orderCommentRemoveSuccess = id => ({
  type: ORDER_COMMENT_REMOVE_SUCCESS,
  id,
  [NOTIFICATION]: {
    message: 'Kommentar borttagen',
  },
});

const orderCommentRemoveFailure = error => ({
  type: ORDER_COMMENT_REMOVE_FAILURE,
  error,
});

const orderCommentUpdateRequest = () => ({
  type: ORDER_COMMENT_UPDATE_REQUEST,
});

const orderCommentUpdateSuccess = comment => ({
  type: ORDER_COMMENT_UPDATE_SUCCESS,
  comment,
  [NOTIFICATION]: {
    message: 'Kommentar uppdaterad',
  },
});

const orderCommentUpdateFailure = error => ({
  type: ORDER_COMMENT_UPDATE_FAILURE,
  error,
});


const extraRowUpdateRequest = () => ({
  type: EXTRA_ROW_UPDATE_REQUEST,
});

const extraRowUpdateSuccess = row => ({
  type: EXTRA_ROW_UPDATE_SUCCESS,
  row,
});

const extraRowUpdateFailure = error => ({
  type: EXTRA_ROW_UPDATE_FAILURE,
  error,
});

const extraRowCreateRequest = () => ({
  type: EXTRA_ROW_CREATE_REQUEST,
});

const extraRowCreateSuccess = (orderId, row) => ({
  type: EXTRA_ROW_CREATE_SUCCESS,
  orderId,
  row,
});

const extraRowCreateFailure = error => ({
  type: EXTRA_ROW_CREATE_FAILURE,
  error,
});

const extraRowRemoveRequest = () => ({
  type: EXTRA_ROW_REMOVE_REQUEST,
});

const extraRowRemoveSuccess = id => ({
  type: EXTRA_ROW_REMOVE_SUCCESS,
  id,
});

const extraRowRemoveFailure = error => ({
  type: EXTRA_ROW_REMOVE_FAILURE,
  error,
});


const activeExtraRowProductsRequest = () => ({
  type: ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST,
});

const activeExtraRowProductsSuccess = products => ({
  type: ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS,
  products,
});

const activeExtraRowProductsFailure = error => ({
  type: ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE,
  error,
});

const activeExtraRowVariantsRequest = () => ({
  type: ACTIVE_EXTRA_ROW_VARIANTS_REQUEST,
});

const activeExtraRowVariantsSuccess = variants => ({
  type: ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS,
  variants,
});

const activeExtraRowVariantsFailure = error => ({
  type: ACTIVE_EXTRA_ROW_VARIANTS_FAILURE,
  error,
});

export const setActiveExtraRow = row => ({
  type: SET_ACTIVE_EXTRA_ROW,
  row,
});

export const setNoteRow = (row, isExtra = false) => ({
  type: SET_NOTE_ROW,
  row,
  isExtra,
});

const orderRowUpdateRequest = () => ({
  type: ORDER_ROW_UPDATE_REQUEST,
});

const orderRowUpdateSuccess = rows => ({
  type: ORDER_ROW_UPDATE_SUCCESS,
  rows,
  [NOTIFICATION]: {
    message: 'Anteckning uppdaterad',
  },
});

const orderRowUpdateFailure = error => ({
  type: ORDER_ROW_UPDATE_FAILURE,
  error,
});

const orderRequest = () => ({
  type: GET_REQUEST,
});

const orderSuccess = (order, apartments, users, specialProducts, salesUsers, apartmentConfig, roomTypes, workerTypes) => ({
  type: GET_SUCCESS,
  apartmentConfig,
  apartments,
  users,
  salesUsers,
  specialProducts,
  order,
  roomTypes,
  workerTypes,
});

const orderFailure = error => ({
  type: GET_FAILURE,
  error,
});

const orderCreateRequest = () => ({
  type: CREATE_REQUEST,
});

const orderCreateSuccess = order => ({
  type: CREATE_SUCCESS,
  order,
  [NOTIFICATION]: {
    message: 'Beställning skapad',
  },
});

const orderCreateFailure = error => ({
  type: CREATE_FAILURE,
  error,
});

const orderUpdateRequest = () => ({
  type: UPDATE_REQUEST,
});

const orderUpdateSuccess = order => ({
  type: UPDATE_SUCCESS,
  order,
  [NOTIFICATION]: {
    message: 'Beställning uppdaterad',
  },
});

const orderUpdateFailure = error => ({
  type: UPDATE_FAILURE,
  error,
});

const orderRowsUpdateRequest = () => ({
  type: ORDER_ROWS_UPDATE_REQUEST,
});

const orderRowsUpdateSuccess = rows => ({
  type: ORDER_ROWS_UPDATE_SUCCESS,
  rows,
  [NOTIFICATION]: {
    message: 'Beställning uppdaterad',
  },
});

const orderRowsUpdateFailure = error => ({
  type: ORDER_ROWS_UPDATE_FAILURE,
  error,
  [NOTIFICATION]: {
    message: 'Nätverksfel, vänligen försök igen',
    level: 'error',
  },
});

const orderRowsClearRequest = () => ({
  type: ORDER_ROWS_CLEAR_REQUEST,
});

const orderRowsClearSuccess = () => ({
  type: ORDER_ROWS_CLEAR_SUCCESS,
  [NOTIFICATION]: {
    message: 'Order uppdaterad',
  },
});

const orderRowsClearFailure = error => ({
  type: ORDER_ROWS_CLEAR_FAILURE,
  error,
});

export const clear = () => ({
  type: CLEAR,
});

export const reset = () => ({
  type: RESET,
});

const filterArchived =
  _.filter({archived: null});

export const fetchData = orderId => async dispatch => {
  dispatch(orderRequest());
  try {
    let order = null;
    let apartmentConfig = null;
    if (!_.isNil(orderId)) {
      order = await GET({endpoint: `/orders/${orderId}`}, dispatch);
      order.comments = await GET({endpoint: `/orders/${orderId}/comments`}, dispatch);
      order.rows = await GET({endpoint: `/orders/${orderId}/rows`}, dispatch);
      order.customRows = await GET({endpoint: `/orders/${orderId}/customrows`}, dispatch);
      order.extraRows = await GET({endpoint: `/orders/${orderId}/extrarows`}, dispatch);
      apartmentConfig = await GET({endpoint: `/apartmentconfigs/${order.apartment.apartmentConfigId}`}, dispatch);
      order.changes = await GET({endpoint: `/orders/${orderId}/changes`}, dispatch);
      apartmentConfig.rooms = _.flow(
        filterArchived,
        _.map(r => ({
          ...r,
          productSlots: filterArchived(r.productSlots),
        }))
      )(apartmentConfig.rooms);
    }
    const apartments = await GET({endpoint: '/orders/apartments'}, dispatch);
    const users = await GET({endpoint: '/orders/users'}, dispatch);
    const salesUsers = await GET({endpoint: `/users/?role=${ADMIN}`}, dispatch);
    const specialProducts = await GET({endpoint: `/products?assortment=${SPECIAL}`}, dispatch);
    const roomTypes = await GET({endpoint: '/roomTypes'}, dispatch);
    const workerTypes = await GET({endpoint: '/workerTypes'}, dispatch);
    dispatch(orderSuccess(
      order,
      apartments,
      users,
      filterArchived(specialProducts),
      salesUsers,
      apartmentConfig,
      filterArchived(roomTypes),
      filterArchived(workerTypes)
    ));
  } catch (err) {
    dispatch(orderFailure(err));
  }
};

export const createOrder = body => async dispatch => {
  dispatch(orderCreateRequest());
  try {
    const order = await POST({
      endpoint: '/orders',
      body,
    }, dispatch);
    dispatch(orderCreateSuccess(order));
  } catch (err) {
    dispatch(orderCreateFailure(err));
  }
};

export const updateOrder = (id, body) => async dispatch => {
  dispatch(orderUpdateRequest());
  try {
    const order = await PUT({
      endpoint: `/orders/${id}`,
      body,
    }, dispatch);
    order.rows = await GET({endpoint: `/orders/${id}/rows`}, dispatch);
    order.extraRows = await GET({endpoint: `/orders/${id}/extrarows`}, dispatch);
    order.customRows = await GET({endpoint: `/orders/${id}/customrows`}, dispatch);
    dispatch(orderUpdateSuccess(order));
  } catch (err) {
    dispatch(orderUpdateFailure(err));
  }
};

export const updateOrderRows = (orderId, {standard, clear} = {}) => async dispatch => {
  dispatch(orderRowsUpdateRequest());
  try {
    const rows = await PUT({
      endpoint: `/orders/${orderId}/rows`,
      body: {
        standard,
        clear,
      },
    }, dispatch);
    dispatch(orderRowsUpdateSuccess(rows));
  } catch (err) {
    dispatch(orderRowsUpdateFailure(err));
  }
};

export const updateOrderRow = (id, body) => async dispatch => {
  dispatch(orderRowUpdateRequest());
  try {
    const rows = await PUT({
      endpoint: `/orderrows/${id}`,
      body,
    }, dispatch);
    dispatch(orderRowUpdateSuccess(rows));
  } catch (err) {
    dispatch(orderRowUpdateFailure(err));
  }
};

export const addOrderComment = (id, body) => async dispatch => {
  dispatch(orderCommentCreateRequest());
  try {
    const comment = await POST({
      endpoint: `/orders/${id}/comments`,
      body,
    }, dispatch);
    dispatch(orderCommentCreateSuccess(comment));
  } catch (err) {
    dispatch(orderCommentCreateFailure(err));
  }
};

export const removeOrderComment = id => async dispatch => {
  dispatch(orderCommentRemoveRequest());
  try {
    await DELETE({endpoint: `/ordercomments/${id}`}, dispatch);
    dispatch(orderCommentRemoveSuccess(id));
  } catch (err) {
    dispatch(orderCommentRemoveFailure(err));
  }
};

export const updateOrderComment = (id, body) => async dispatch => {
  dispatch(orderCommentUpdateRequest());
  try {
    const comment = await PUT({
      endpoint: `/ordercomments/${id}`,
      body,
    }, dispatch);
    dispatch(orderCommentUpdateSuccess(comment));
  } catch (err) {
    dispatch(orderCommentUpdateFailure(err));
  }
};


export const createExtraRow = (orderId, body) => async dispatch => {
  dispatch(extraRowCreateRequest());
  try {
    const row = await POST({
      endpoint: `/orders/${orderId}/extrarows`,
      body,
    }, dispatch);
    dispatch(extraRowCreateSuccess(orderId, row));
    dispatch(addNotification('Produkt tillagd', 'success'));
  } catch (err) {
    dispatch(extraRowCreateFailure(err));
  }
};

export const updateExtraRow = (id, body) => async dispatch => {
  dispatch(extraRowUpdateRequest());
  try {
    const row = await PUT({
      endpoint: `/extraorderrows/${id}`,
      body,
    }, dispatch);
    dispatch(extraRowUpdateSuccess(row));
    dispatch(addNotification('Produkt uppdaterad', 'success'));
  } catch (err) {
    dispatch(extraRowUpdateFailure(err));
  }
};

export const removeExtraRow = rowId => async dispatch => {
  dispatch(extraRowRemoveRequest());
  try {
    await DELETE({
      endpoint: `/extraorderrows/${rowId}`,
    }, dispatch);
    dispatch(extraRowRemoveSuccess(rowId));
    dispatch(addNotification('Produkt borttagen', 'success'));
  } catch (err) {
    dispatch(extraRowRemoveFailure(err));
  }
};

export const fetchActiveExtraRowProducts = () => async dispatch => {
  dispatch(activeExtraRowProductsRequest());
  const allowedAssortments = [
    STANDARD,
    SPECIAL,
  ];
  try {
    const products = await GET({endpoint: '/products'}, dispatch);
    const nonArchivedProducts = _.filter({archived: null}, products);
    const allowedProducts = _.filter(p => _.includes(p.assortment, allowedAssortments), nonArchivedProducts);
    dispatch(activeExtraRowProductsSuccess(allowedProducts));
  } catch (err) {
    dispatch(activeExtraRowProductsFailure(err));
  }
};

export const fetchActiveExtraRowVariants = id => async dispatch => {
  dispatch(activeExtraRowVariantsRequest());
  try {
    const variants = await GET({endpoint: `/products/${id}/variants`}, dispatch);
    const nonArchivedVariants = _.filter({archived: null}, variants);
    dispatch(activeExtraRowVariantsSuccess(nonArchivedVariants));
  } catch (err) {
    dispatch(activeExtraRowVariantsFailure(err));
  }
};

export const clearOrderRows = orderId => async dispatch => {
  dispatch(orderRowsClearRequest());
  try {
    await POST({
      endpoint: `/orders/${orderId}/clearorderrows`,
      expectBody: false,
    }, dispatch);
    dispatch(orderRowsClearSuccess());
  } catch (err) {
    dispatch(orderRowsClearFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/orderView.js